import { render } from "./LiteExam.vue?vue&type=template&id=6ac796f0"
import script from "./LiteExam.vue?vue&type=script&lang=js"
export * from "./LiteExam.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__